import React from 'react';
import numeral from 'numeral';
import { Popup, Icon, Button } from 'semantic-ui-react';

import PrivateDataComponent from '../private-data-component';


const sf = num => numeral(num).format('0a');

const FacebookImpressions = ({ latestStatistic, popupToggleHandler }) => {
  const insights = latestStatistic.insights;
  if (insights) {
    return (
      <Button
        color="blue"
        inverted
        icon="pie graph"
        labelPosition="left"
        fluid
        content={sf(insights.totalVideoImpressions)}
        onClick={() => popupToggleHandler(latestStatistic)}
        size="small"
      />
    );
  }
  return (
    <PrivateDataComponent />
  );
};

export default FacebookImpressions;



/** WEBPACK FOOTER **
 ** ./src/components/facebook-impressions/index.js
 **/